module.exports = __webpack_public_path__ + "static/media/VOLKSWAGEN.8412bc52.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/agsm/img/carBrands/VOLKSWAGEN.png
 ** module id = 1662
 ** module chunks = 0
 **/